import React, { Fragment } from "react";

export default function() {
  return (
    <Fragment>
      <h3>Non disponibile</h3>
    </Fragment>
  );
}
